import "client-only";
import Calculatorpage from "app/calculator/page";
import { usePathname } from "next/navigation";
import BottomDrawer from "./bottomdrawer";
import Drawer from "./drawer";
import Login from "./login";
import styles from "./header.module.css";

import Link from "next/link";
import Image from "next/image";
import { useCartFetch } from "context/cart";
import EmptyCart from "./emptycart";
import { Title, Description } from "@radix-ui/react-dialog";
import { GrAdd, GrSubtract } from "react-icons/gr";
import Ripple from "./ripple";
import FillSpace from "./fillspace";
import DashbordList, { AdminList } from "./dashbordlist";
import { useAuth } from "hooks/useUser";
import { useState } from "react";
import avatar from "assets/images/avatar.png";
import { useCartStore } from "states/cart";

type ModalToggle = {
  open: boolean;
  onClose: (open: boolean) => void;
};

export function LoginModal({ open, onClose }: ModalToggle) {
  return (
    <Drawer open={open} onClose={onClose} title="Login to Imperium">
      <Login />
    </Drawer>
  );
}

export function CalculatorModal({ open, onClose }: ModalToggle) {
  return (
    <BottomDrawer open={open} onClose={onClose} title="Energy Needs Calculator">
      <div className="__modal">
        <div
          style={{
            position: "relative",
          }}>
          <Calculatorpage onClose={onClose} />
        </div>
      </div>
    </BottomDrawer>
  );
}

export function CartModal({ open, onClose }: ModalToggle) {
  const { cart, changeQty, removeFromCart } = useCartStore();
  const { data = [], isLoading } = useCartFetch();
  return (
    <Drawer open={open} onClose={onClose}>
      {isLoading ? (
        <FillSpace>
          <Ripple />
        </FillSpace>
      ) : data.length ? (
        <>
          <div className={styles.sub}>
            <span>Subtotal</span>
            <p>
              &#x20A6;
              {data
                .reduce((acc, curr) => {
                  return acc + (curr.price + curr.installation_fee) * cart[curr.id];
                }, 0)
                ?.toLocaleString()}
            </p>
            <Link href="/checkout" onClick={() => onClose(false)} className="btn btn-lg btn-green">
              Checkout
            </Link>
          </div>
          <ul>
            {data.map((product) => {
              return (
                <li key={product.id} className={styles.item}>
                  <div>
                    <img src={product.primary_img_url} alt="" />
                  </div>
                  <div>
                    <div>
                      <p className="sr-only">{product.name}</p>
                      <p>&#x20A6;{((product.price + product.installation_fee) * cart[product.id])?.toLocaleString()}</p>
                      <div className={styles.control}>
                        <button
                          type="button"
                          title="Subtract"
                          onClick={() => {
                            const tbA = cart[product.id];
                            changeQty(product.id, tbA < 2 ? tbA : tbA - 1);
                          }}>
                          <GrSubtract />
                        </button>
                        <input
                          type="number"
                          min={1}
                          max={product.qty_available}
                          step={1}
                          value={cart[product.id]}
                          onChange={(e) => {
                            const value = e.target.valueAsNumber;

                            changeQty(
                              product.id,
                              isNaN(value) || value < 1
                                ? 1
                                : value >= product.qty_available
                                ? product.qty_available
                                : value
                            );
                          }}
                        />
                        <button
                          type="button"
                          title="Add"
                          onClick={() => {
                            const tbA = cart[product.id];
                            changeQty(product.id, tbA >= product.qty_available ? product.qty_available : tbA + 1);
                            // setTbA((tbA) => (tbA > 10 ? tbA : tbA + 1));
                          }}>
                          <GrAdd />
                        </button>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        removeFromCart(product.id);
                      }}>
                      Remove
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
        </>
      ) : (
        <div className={styles.cartEmpty}>
          <EmptyCart />
          <Title>Your cart is empty!</Title>
          <Description>
            Your cart is currently empty, but take a look at our wide range of cutting-edge alternative energy products
            and find the perfect solution for you.
          </Description>
          <Link href="/shop" onClick={() => onClose(false)} className="btn btn-lg btn-green">
            Browse Products
          </Link>
        </div>
      )}
    </Drawer>
  );
}

export function LoggedInModal() {
  const { data } = useAuth();
  const [open, setOpen] = useState(false);
  const pathName = usePathname();
  return (
    <>
      <button
        onClick={() => {
          setOpen(true);
        }}>
        {data.first_name}
      </button>
      <Drawer open={open} onClose={setOpen}>
        <div
          onClick={(e) => {
            if (e.target === document.activeElement) {
              setOpen(false);
            }
          }}>
          <div className={styles.tav}>
            <div>
              <Image src={avatar || data} alt={data.first_name} width={56} />
            </div>
            <div>
              <Title>
                {data.first_name} {data.last_name}
              </Title>
              <p>{data.role === "vendor" ? "Imperium Vendor" : "Account Holder"}</p>
            </div>
          </div>
          {pathName?.includes("/vendor") ? <AdminList /> : <DashbordList />}
        </div>
      </Drawer>
    </>
  );
}
